import React from 'react';
import { PropTypes } from 'prop-types';
import { map, uniqueId } from 'lodash';
import { Check2 as Check } from '@origo_vl_banking/icons';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const StepperContainer = styled.div`
  display: flex;
  flex-direction: ${({ mobile }) => !mobile && 'column'};
  width: 100%;
  justify-content: ${({ mobile }) => (mobile ? 'space-between' : 'center')};
  align-items: center;
`;

const StepsContainer = styled.div`
  display: flex;
  width: ${({ mobile }) => !mobile && '100%'};
  align-items: center;
  padding-top: ${({ mobile }) => !mobile && '48px'};
`;

const Step = styled.div`
  height: 35px;
  width: 35px;
  min-height: 35px;
  min-width: 35px;
  background: ${({
    currentStep, theme, activeStepColor, inActiveStepColor,
  }) =>
    (currentStep ? activeStepColor || theme.iconColor : inActiveStepColor || '#DBE1DD')};
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ currentStep, theme }) => (currentStep ? 'white' : theme.iconColor)};
  font-weight: bold;
`;

const StepLine = styled.div`
  background: ${({
    currentStep, theme, activeStepColor, inActiveStepColor,
  }) =>
    (currentStep ? activeStepColor || theme.iconColor : inActiveStepColor || '#DBE1DD')};
  height: 5px;
  min-width: 50px;
  width: 100%;
`;

const Heading = styled.h2`
  font-size: 35px;
  font-weight: lighter;
  line-height: 47px;
  text-align: ${({ mobile }) => (mobile ? 'start' : 'center')};
  width: ${({ mobile }) => !mobile && '100%'};
  /* margin: ${({ mobile }) => !mobile && '0px'}; */
  margin: 0;


  @media (max-width: 325px) {
    font-size: 18px;
  }
`;

const StepWithText = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: ${({ mobile }) => mobile && '6px'};

  &:last-child {
    padding-right: ${({ mobile }) => mobile && '0px'};
  }
`;

const StepTextContainer = styled.div`
  position: relative;
`;

const StepText = styled.div`
  position: absolute;
  top: 24px;
  text-align: center;
  color: ${({ currentStep, theme }) => (currentStep ? theme.iconColor : '#9b9b9b')};
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  width: 125px;
  right: -48px;
`;

const StepperContent = styled.div`
  margin-right: ${({ isIcon }) => (isIcon ? '1px' : '0px')};
  margin-top: ${({ isIcon }) => (isIcon ? '2px' : '0px')};

  color: ${({
    currentStep, theme, activeFontColor, inActiveFontColor,
  }) =>
    (currentStep ? activeFontColor || theme.iconColor : inActiveFontColor || '#9b9b9b')};
`;

const SpariStepper = ({
  currentStep,
  steps,
  heading,
  mobile,
  activeStepColor,
  activeFontColor,
  inActiveStepColor,
  inActiveFontColor,
}) => (
  <StepperContainer mobile={mobile}>
    {heading && <Heading mobile={mobile}>{heading}</Heading>}
    <StepsContainer mobile={mobile}>
      {map(steps, (step, index) => {
        const elapsed = currentStep > index + 1;
        const current = currentStep === index + 1;
        return (
          <React.Fragment key={uniqueId()}>
            <StepWithText mobile={mobile}>
              <Step
                activeStepColor={activeStepColor}
                inActiveStepColor={inActiveStepColor}
                currentStep={elapsed || current}
              >
                <StepperContent
                  activeFontColor={activeFontColor}
                  inActiveFontColor={inActiveFontColor}
                  currentStep={elapsed || current}
                  isIcon={elapsed}
                >
                  {elapsed ? <Check size={18} color="white" /> : index + 1}
                </StepperContent>
              </Step>
              {!mobile && (
                <StepTextContainer>
                  <StepText currentStep={elapsed || current}>
                    {step.textId && <FormattedMessage id={step.textId} />}
                  </StepText>
                </StepTextContainer>
              )}
            </StepWithText>
            {steps.length !== index + 1 && !mobile && <StepLine currentStep={elapsed} />}
          </React.Fragment>
        );
      })}
    </StepsContainer>
  </StepperContainer>
);

SpariStepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentStep: PropTypes.number.isRequired,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  mobile: PropTypes.bool,
  activeStepColor: PropTypes.string,
  activeFontColor: PropTypes.string,
  inActiveStepColor: PropTypes.string,
  inActiveFontColor: PropTypes.string,
};

SpariStepper.defaultProps = {
  heading: null,
  mobile: false,
  activeStepColor: null,
  activeFontColor: null,
  inActiveStepColor: null,
  inActiveFontColor: null,
};

export default SpariStepper;
